import { Service, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

@Service()
export class PrefixTitleStrategy extends TitleStrategy {
    private readonly title = inject(Title);

    private static readonly titlePrefix = 'Benefits For You - ';

    override updateTitle(snapshot: RouterStateSnapshot): void {
        const title = this.buildTitle(snapshot);
        this.title.setTitle(`${PrefixTitleStrategy.titlePrefix}${title}`);
    }
}
